const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

export function productOrigin(configured, localPort, productionOrigin, hostname = window.location.hostname) {
  const localPage = LOCAL_HOSTS.has(hostname);
  const fallback = localPage ? `http://localhost:${localPort}` : productionOrigin;
  try {
    const url = new URL(configured || fallback);
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password) return fallback;
    if (localPage && !LOCAL_HOSTS.has(url.hostname)) return fallback;
    return url.origin;
  } catch { return fallback; }
}

export const SITE_ORIGIN = productOrigin(process.env.REACT_APP_SITE_URL, 3002, "https://www.thedoar.com");
export const SPACE_ORIGIN = productOrigin(process.env.REACT_APP_SPACE_URL, 3001, "https://doarspace.com");
export const AI_ORIGIN = productOrigin(process.env.REACT_APP_AI_URL, 3003, "https://thedoar.ai");
export const GATEWAY_ORIGIN = productOrigin(process.env.REACT_APP_GATEWAY_URL, 3000, "https://todoar.co");
